import React from 'react';

const NotFound = () => (
    <div className="text-center mt-5 h-100">
        <h1 className="text-white mt-5">404, Page Not found</h1>
    </div>
)

export default NotFound;
